export type ThemePref = 'system' | 'light' | 'dark';
const KEY = 'unitly-theme';

export function readTheme(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(pref: ThemePref) {
  const root = document.documentElement;
  if (pref === 'system') delete root.dataset.theme;
  else root.dataset.theme = pref;
  try {
    if (pref === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch {
    /* storage unavailable: theme still applies for this session */
  }
}

export function rememberOrg(slug: string) {
  try {
    localStorage.setItem('unitly-last-org', slug);
  } catch {
    /* ignore */
  }
}
export function lastOrg(): string | null {
  try {
    return localStorage.getItem('unitly-last-org');
  } catch {
    return null;
  }
}
